import React from 'react';

export function IconCheckbox({
  checked,
  ...rest
}: {
  checked: boolean;
}): JSX.Element {
  return checked ? (
    <svg width={16} height={16} fill="none" {...rest}>
      <rect
        x={0.5}
        y={0.5}
        width={15}
        height={15}
        rx={1.5}
        fill="#fff"
        stroke="#D2DFEF"
      />
      <rect
        x={0.5}
        y={0.5}
        width={15}
        height={15}
        rx={1.5}
        fill="#fff"
        stroke="#D2DFEF"
      />
      <rect
        x={0.5}
        y={0.5}
        width={15}
        height={15}
        rx={1.5}
        fill="#fff"
        stroke="#D2DFEF"
      />
      <rect
        x={0.5}
        y={0.5}
        width={15}
        height={15}
        rx={1.5}
        fill="#fff"
        stroke="#D2DFEF"
      />
      <rect
        x={0.5}
        y={0.5}
        width={15}
        height={15}
        rx={1.5}
        fill="#fff"
        stroke="#D2DFEF"
      />
      <rect width={16} height={16} rx={2} fill="#2326DE" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.354 5.604l-5.729 5.728-2.979-2.978.708-.708 2.271 2.272 5.021-5.022.708.708z"
        fill="#fff"
      />
    </svg>
  ) : (
    <svg width={16} height={16} fill="none" {...rest}>
      <rect
        x={0.5}
        y={0.5}
        width={15}
        height={15}
        rx={1.5}
        fill="#fff"
        stroke="#D2DFEF"
      />
    </svg>
  );
}
